var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
    fill: "#985184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "#FBB945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "#1AD3BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30H4a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h21V30Z",
    fill: "#FBB945"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 30H25v12h21a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4Z",
    fill: "#1AD3BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30h14c6.627 0 12 5.373 12 12H24c-6.627 0-12-5.373-12-12Z",
    fill: "#985184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.f450a84572cf6a60438f5518e1ac8c77.svg";
export { ForwardRef as ReactComponent };